/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.ActivityLog {
    export class ActivityLogUpdateSize implements angular.IDirective {
        require = '^mdVirtualRepeatContainer';
        scope = {
            toogle: '=activityLogUpdateSize'
        };
        restrict = 'A';
        link = (scope: any, element: any, attrs: angular.IAttributes, mdVirtualRepeatContainer: any) => {
            let previousHeight: number = 0;

            let getHeigth = () => {
                let computedStyle = getComputedStyle(element[0].parentNode);
                let elementHeight = element[0].parentNode.clientHeight;  // height with padding
                elementHeight -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
                return elementHeight;                
            };

            scope.$watch(() => scope.toogle, (newValue, oldValue) => {
                if (newValue === oldValue) return;

                this.$timeout(() => {
                    const newHeight = getHeigth();
                    if (newHeight === previousHeight) return;
                    previousHeight = newHeight;
                    mdVirtualRepeatContainer.setSize_(newHeight);
                    mdVirtualRepeatContainer.updateSize();

                });
            });
        };

        constructor(
            protected $timeout
        ) { }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => new ActivityLogUpdateSize($timeout);
            directive.$inject = [
                '$timeout'
            ];

            return directive;
        }
    }

    angular.module('meevo.plugins.activityLog')
        .directive('activityLogUpdateSize', ActivityLogUpdateSize.factory());
}